import { render, staticRenderFns } from "./TenderItemPanel.vue?vue&type=template&id=fd3fda06&scoped=true"
import script from "./TenderItemPanel.vue?vue&type=script&lang=js"
export * from "./TenderItemPanel.vue?vue&type=script&lang=js"
import style0 from "./TenderItemPanel.vue?vue&type=style&index=0&id=fd3fda06&prod&lang=scss&scoped=true"
import style1 from "./TenderItemPanel.vue?vue&type=style&index=1&id=fd3fda06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd3fda06",
  null
  
)

export default component.exports